<div class="edit-customer-root">
  <div class="edit-customers-header">
    <div class="action-buttons">
      <div class="payment-div" *ngIf="!customer.isPaid && permissionsService.isServiceRequestAuthCreateEditAllowed">
        <button class="btn btn-header" (click)="confirmPayment()">
          {{ "COMMON.CONFIRM_PAYMENT" | translate }}
        </button>
      </div>
    </div>
  </div>
  <div class="edit-customers-body">
    <div class="card container">
      <div class="row">
        <div class="col-5">
          {{ "COMMON.MBC_DETAILS.CUSTOMER_NAME" | translate }}
        </div>
        <div class="col-7">{{ customer.customerName | hasValue }}</div>
      </div>
      <div class="row">
        <div class="col-5">
          {{ "COMMON.TABLE_HEADERS.APP_NUM" | translate }}
        </div>
        <div class="col-7">{{ customer.applicationNumber | hasValue }}</div>
      </div>
      <div class="row">
        <div class="col-5">
          {{ "COMMON.CUSTOMER.ACCOUNT_NUMBER" | translate }}
        </div>
        <div class="col-7">{{ customer.accountNumber | hasValue }}</div>
      </div>
      <div class="row">
        <div class="col-5">{{ contractNumber }}</div>
        <div class="col-7">
          {{ customer.spn | hasValue }}
        </div>
      </div>
      <div class="row">
        <div class="col-5">{{ "COMMON.USER.EMAIL" | translate }}</div>
        <div class="col-7">
          {{ customer.email | hasValue }}
        </div>
      </div>
      <div class="row">
        <div class="col-5">{{ "COMMON.MBC_DETAILS.PHONE_NO" | translate }}</div>
        <div class="col-7">
          {{ customer.phoneNumber | hasValue }}
        </div>
      </div>
      <div class="row">
        <div class="col-5">{{ "COMMON.BU.SINGLE" | translate }}</div>
        <div class="col-7">
          {{ customer.area.regionName | hasValue }}
        </div>
      </div>
      <div class="row">
        <div class="col-5">{{ "COMMON.UT.SINGLE" | translate }}</div>
        <div class="col-7">
          {{ customer.area.name | hasValue }}
        </div>
      </div>
      <div class="row">
        <div class="col-4">{{'SERVICE_POINT_DATA.FEEDER_NAME' | translate}}</div>

        <div class="col-8">
          {{ customer?.feederName | hasValue }}
        </div>
      </div>
      <div class="row">
        <div class="col-4">{{'SERVICE_POINT_DATA.FEEDER_NUMBER' | translate}}</div>

        <div class="col-8">
          {{ customer?.feederNumber | hasValue }}
        </div>
      </div>
      <div class="row">
        <div class="col-4">{{'SERVICE_POINT_DATA.DS_NAME' | translate}}</div>

        <div class="col-8">
          {{ customer?.dsName | hasValue }}
        </div>
      </div>
      <div class="row">
        <div class="col-4">{{'SERVICE_POINT_DATA.DS_NUMBER' | translate}}</div>

        <div class="col-8">
          {{ customer?.dsNumber | hasValue }}
        </div>
      </div>
      <div class="row">
        <div class="col-4">{{'SERVICE_POINT_DATA.SERVICE_TYPE' | translate}}</div>

        <div class="col-8">
          {{ customer?.serviceType | hasValue }}
        </div>
      </div>
      <div class="row">
        <div class="col-4">{{'SERVICE_POINT_DATA.SUB_SERVICE_TYPE' | translate}}</div>

        <div class="col-8">
          {{ customer.subServiceType | hasValue }}
        </div>
      </div>
      <div *ngIf="customer.identificationIssueDate" class="row">
        <div class="col-5">Identification Issue Date</div>
        <div class="col-7">
          {{ customer.identificationIssueDate | date : "dd/MM/yyyy" }}
        </div>
      </div>
      <div *ngIf="customer.identificationExpiryDate" class="row">
        <div class="col-5">Identification Expiry Date</div>
        <div class="col-7">
          {{ customer.identificationExpiryDate | date : "dd/MM/yyyy" }}
        </div>
      </div>
    </div>
    <div class="right-column">
      <div class="card container">
        <div class="row">
          <div class="col-5">
            {{ "ROLE_MANAGEMENT.DESCRIPTION_SERVICE_CONNECTION" | translate }}
          </div>
          <div class="col-7">
            {{ customer.desctiptionOfServiceConnection | hasValue }}
          </div>
        </div>
        <div class="row">
          <div class="col-5">{{ "COMMON.QUANTITY" | translate }}</div>
          <div class="col-7">
            {{ customer.quantity | hasValue }}
          </div>
        </div>
        <div class="row">
          <div class="col-5">{{ "COMMON.AMOUNT" | translate }}</div>
          <div class="col-7">{{ customer.amount | hasValue }}</div>
        </div>

        <div class="row">
          <div class="col-5">{{ "COMMON.DATE_INVOICE" | translate }}</div>
          <div class="col-7">{{ customer.dateInvoiceWasSent | hasValue }}</div>
        </div>

      </div>
      <div class="card container meter-request-card">
        <div class="meter-request-header">
          <label class="section-label">{{'METER_REQUEST.TITLE' | translate}}</label>
          <span class="count-badge">{{ customer?.relatedAccounts?.length || 0 }}</span>
        </div>
        <div class="meter-request-table">
          <div class="row table-header-row">
            <div class="col-3">{{'METER_REQUEST.SERVICE_ORDER_ID' | translate}}</div>
            <div class="col-3">{{'METER_REQUEST.ACCOUNT_NUMBER' | translate}}</div>
            <div class="col-3">{{'METER_REQUEST.SPN' | translate}}</div>
            <div class="col-3">{{'METER_REQUEST.PHASE_REQUESTED' | translate}}</div>
          </div>
          <div class="row table-data-row" *ngFor="let account of customer?.relatedAccounts">
            <div class="col-3">{{ account.serviceOrderId | hasValue }}</div>
            <div class="col-3">{{ account.accountNumber | hasValue }}</div>
            <div class="col-3">{{ account.spn | hasValue }}</div>
            <div class="col-3">{{ account.phaseRequested | hasValue }}</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
